exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-uploader .el-upload[data-v-456be3d7]{border:1px dashed #f7f7f7;border-radius:10px;cursor:pointer;position:relative;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.avatar-uploader .el-upload[data-v-456be3d7]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-456be3d7]{font-size:28px;color:#8c939d;width:148px;height:148px;line-height:148px;text-align:center}.avatar_img[data-v-456be3d7]{width:148px;height:148px;border-radius:6px}.tips[data-v-456be3d7]{font-size:12px;color:#9c9a9a}", ""]);

// exports
